import { Button, Heading, HFlow, Icon, Modal, ModalBody, ModalFooter, Text, VFlow } from 'bold-ui'
import { useErrorHandler } from 'components/error'
import { toEsusParameters } from 'components/esus'
import { FormRenderProps, SubmitButton, TextAreaField } from 'components/form'
import { useSalvarJustificativaVisualizarProntuarioMutation } from 'graphql/hooks.generated'
import React from 'react'
import { Form } from 'react-final-form'
import { useHistory, useLocation } from 'react-router'
import { metaPath } from 'util/metaPath'
import { createValidator, required } from 'util/validation'

interface JustificativaModalProps {
  cidadaoId: string
  isModalOpen: boolean
  handleModalClose(): void
}

interface JustificativaFormModel {
  justificativa: string
}

export const validate = createValidator<JustificativaFormModel>({
  justificativa: [required],
})

export const JustificativaModal = (props: JustificativaModalProps) => {
  const { cidadaoId, isModalOpen } = props

  const [salvarJustificativaVisualizarProntuario] = useSalvarJustificativaVisualizarProntuarioMutation()
  const history = useHistory()
  const location = useLocation()
  const handleRejection = useErrorHandler()
  const path = metaPath<JustificativaFormModel>()

  const handleOnSubmit = (values: JustificativaFormModel) => {
    salvarJustificativaVisualizarProntuario({
      variables: { input: { idCidadao: cidadaoId, justificativa: values.justificativa } },
    })
      .then(() => {
        history.push(
          `/cidadao/visualizarProntuario?${toEsusParameters({
            cidadaoId: cidadaoId,
            isVisualizarProntuario: true,
            pecBackLink: btoa(location.pathname + location.search),
          })}`
        )
      })
      .catch(handleRejection)
  }

  const justificativaModalForm = (formProps: FormRenderProps) => {
    return (
      <Modal open={isModalOpen} onClose={props.handleModalClose} size='auto' closeOnBackdropClick={false}>
        <ModalBody>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '2.45rem' }}>
            <Icon icon='exclamationTriangleOutline' fill='alert' size={3} style={{ marginRight: '1rem' }} />
            <VFlow vSpacing={0}>
              <Heading level={1}>Justificativa para visualizar prontuário</Heading>
              <Text>É obrigatória a apresentação de uma justificativa para visualizar o prontuário.</Text>
            </VFlow>
          </div>
          <TextAreaField
            style={{ resize: 'none', height: '5rem' }}
            name={path.justificativa}
            label='Justificativa'
            maxLength={500}
            required
          />
        </ModalBody>
        <ModalFooter>
          <HFlow justifyContent='flex-end'>
            <Button onClick={props.handleModalClose}>Cancelar</Button>
            <SubmitButton title='Salvar' kind='primary' handleSubmit={formProps.handleSubmit}>
              Salvar
            </SubmitButton>
          </HFlow>
        </ModalFooter>
      </Modal>
    )
  }

  return <Form render={justificativaModalForm} validate={validate} onSubmit={handleOnSubmit} />
}
